"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import CommonBorderedRadioButton from "@/components/utils/radio/CommonBorderedRadioButton";
import CreateWaveVotingRep from "./CreateWaveVotingRep";
import NegativeVotingToggle from "./NegativeVotingToggle";
import TimeWeightedVoting from "./TimeWeightedVoting";
import type { TimeWeightedVotingConfig } from "./types";
const VOTING_TYPES_ORDER: Record<ApiWaveCreditType, number | undefined> = {
  [ApiWaveCreditType.TdhPlusXtdh]: 0,
  [ApiWaveCreditType.Tdh]: 1,
  [ApiWaveCreditType.Rep]: 2,
  [ApiWaveCreditType.Xtdh]: undefined
};
export default function CreateWaveVoting(t0) {
  const $ = _c(30);
  const {
    waveType,
    selectedType,
    category,
    profileId,
    errors,
    onTypeChange,
    setCategory,
    setProfileId,
    timeWeighted,
    onTimeWeightedChange
  } = t0;
  const [allowNegativeVotes, setAllowNegativeVotes] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiWaveType.Chat]: "How Drops are Rated",
      [ApiWaveType.Rank]: "How Drops are Voted",
      [ApiWaveType.Approve]: "How Drops are Voted"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const TITLES = t1;
  if (!selectedType) {
    return null;
  }
  const t2 = TITLES[waveType];
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="tw-mb-0 tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50">{t2}</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = Object.keys(VOTING_TYPES_ORDER);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (t4 as ApiWaveCreditType[]).filter(_temp);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onTypeChange || $[6] !== selectedType) {
    t6 = t5.map(votingType_0 => <CommonBorderedRadioButton key={votingType_0} type={votingType_0} selected={selectedType} disabled={false} label={`By ${WAVE_VOTING_LABELS[votingType_0]}`} onChange={onTypeChange} />);
    $[5] = onTypeChange;
    $[6] = selectedType;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== category || $[9] !== errors || $[10] !== profileId || $[11] !== selectedType || $[12] !== setCategory || $[13] !== setProfileId) {
    t7 = selectedType === ApiWaveCreditType.Rep && <div className="tw-col-span-full"><CreateWaveVotingRep category={category} profileId={profileId} errors={errors} setCategory={setCategory} setProfileId={setProfileId} /></div>;
    $[8] = category;
    $[9] = errors;
    $[10] = profileId;
    $[11] = selectedType;
    $[12] = setCategory;
    $[13] = setProfileId;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="tw-mt-3 tw-grid lg:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-4">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== allowNegativeVotes || $[19] !== waveType) {
    t9 = waveType !== ApiWaveType.Chat && <NegativeVotingToggle allowNegativeVotes={allowNegativeVotes} onChange={setAllowNegativeVotes} />;
    $[18] = allowNegativeVotes;
    $[19] = waveType;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== onTimeWeightedChange || $[22] !== timeWeighted || $[23] !== waveType) {
    t10 = waveType === ApiWaveType.Rank && <TimeWeightedVoting config={timeWeighted} onChange={onTimeWeightedChange} />;
    $[21] = onTimeWeightedChange;
    $[22] = timeWeighted;
    $[23] = waveType;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t3 || $[27] !== t8 || $[28] !== t9) {
    t11 = <div>{t3}{t8}{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t3;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}
function _temp(votingType) {
  return VOTING_TYPES_ORDER[votingType] !== undefined;
}